import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'

export const routeBackOfficeOrdersAdminCommon = [
  {
    route: 'HistoryOrders',
    menuGroup: MENU_GROUPS.MONITORING,
    text: 'Gestion des commandes',
    icon: ShoppingCartIcon,
    href: '/backoffice/insight/order',
    menuHeader: true,
    position: 200,
  },
  {
    route: 'DetailOrder',
    text: 'Détails des commandes',
    href: '/backoffice/insight/order/detail-order/[orderId]',
  },
]
